export class CompanyQuarter {
    id!: string
    name!: string
    quarter!: number
    year!: number
    startDate!: Date
    endDate!: Date
}
